const BASE = process.env.REACT_APP_API_URL || "/api";

function getToken() {
  return localStorage.getItem("kk_token");
}

async function request(method, path, body) {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Sunucu hatası");
  }
  return res.json();
}

export const api = {
  getPublicUsers: () => request("GET", "/users/public"),
  // Auth
  login: (username, password) => request("POST", "/auth/login", { username, password }),

  // Users
  getUsers:   ()          => request("GET",    "/users"),
  addUser:    (data)      => request("POST",   "/users", data),
  updateUser: (u, data)   => request("PUT",    `/users/${u}`, data),
  deleteUser: (u)         => request("DELETE", `/users/${u}`),

  // Entries
  getEntries: (kasaKey, date) => request("GET", `/entries/${kasaKey}${date ? `?date=${date}` : ""}`),
  getDates:   (kasaKey)       => request("GET", `/entries/${kasaKey}/dates/all`),
  addEntry:   (kasaKey, data) => request("POST",   `/entries/${kasaKey}`, data),
  deleteEntry:(id)            => request("DELETE", `/entries/${id}`),
  updateEntry:(id, data)      => request("PUT",    `/entries/${id}`, data),

  // Delete requests
  getDeleteRequests:    ()        => request("GET",    "/requests/delete"),
  addDeleteRequest:     (data)    => request("POST",   "/requests/delete", data),
  approveDeleteRequest: (id)      => request("DELETE", `/requests/delete/${id}?approve=1`),
  rejectDeleteRequest:  (id)      => request("DELETE", `/requests/delete/${id}?approve=0`),

  // Edit requests
  getEditRequests:    ()     => request("GET",    "/requests/edit"),
  addEditRequest:     (data) => request("POST",   "/requests/edit", data),
  approveEditRequest: (id)   => request("DELETE", `/requests/edit/${id}?approve=1`),
  rejectEditRequest:  (id)   => request("DELETE", `/requests/edit/${id}?approve=0`),

  // Messages
  getGroupMessages:   ()           => request("GET",  "/messages/group"),
  getPrivateMessages: (username)   => request("GET",  `/messages/private/${username}`),
  sendMessage:        (data)       => request("POST", "/messages", data),
  getUnreadCount:     ()           => request("GET",  "/messages/unread"),
  markGroupRead:      ()           => request("POST", "/messages/group/read"),
  clearGroupMessages: ()           => request("DELETE", "/messages/group/all"),

  // Advances
  getAdvance:      (kasaKey, date) => request("GET",  `/advances/${kasaKey}${date ? `?date=${date}` : ""}`),
  getAllAdvances:   ()              => request("GET",  "/advances/all"),
  addAdvance:      (data)          => request("POST", "/advances", data),
  approveAdvance:  (id)            => request("PUT",    `/advances/${id}/approve`),
  cancelAdvance:   (id)            => request("DELETE", `/advances/${id}`),

  // Customers
  getCustomers:          (q)    => request("GET",    "/customers" + (q ? "?q=" + encodeURIComponent(q) : "")),
  getCustomer:           (id)   => request("GET",    `/customers/${id}`),
  addCustomer:           (data) => request("POST",   "/customers", data),
  updateCustomer:        (id, data) => request("PUT", `/customers/${id}`, data),
  deleteCustomer:        (id)   => request("DELETE", `/customers/${id}`),
  addSubscription:       (id, data) => request("POST", `/customers/${id}/subscriptions`, data),
  deleteSubscription:    (id)   => request("DELETE", `/customers/subscriptions/${id}`),

  // Scores
  getScores:  ()       => request("GET",  "/scores"),
  saveScore:  (score)  => request("POST", "/scores", { score }),

  // Dashboard
  getDashboardSummary: ()           => request("GET",  "/dashboard/summary"),
  getTodos:            ()           => request("GET",  "/dashboard/todos"),
  addTodo:             (data)       => request("POST", "/dashboard/todos", data),
  updateTodo:          (id, data)   => request("PUT",  `/dashboard/todos/${id}`, data),
  deleteTodo:          (id)         => request("DELETE", `/dashboard/todos/${id}`),
  getAdminNotes:       (date)       => request("GET",  `/dashboard/adminnotes?date=${date}`),
  addAdminNote:        (data)       => request("POST", "/dashboard/adminnotes", data),
  deleteAdminNote:     (id)         => request("DELETE", `/dashboard/adminnotes/${id}`),
  getEvents:           ()           => request("GET",  "/dashboard/events"),
  addEvent:            (data)       => request("POST", "/dashboard/events", data),
  deleteEvent:         (id)         => request("DELETE", `/dashboard/events/${id}`),

  // Logs
  getLogs: () => request("GET", "/logs"),
  addLog:  (data) => request("POST", "/logs", data),

  // Notes
  getNotes:   (kasaKey, date) => request("GET",    `/notes/${kasaKey}${date ? `?date=${date}` : ""}`),
  addNote:    (kasaKey, data) => request("POST",   `/notes/${kasaKey}`, data),
  deleteNote: (id)            => request("DELETE", `/notes/${id}`),
};

export function saveSession(token, user) {
  localStorage.setItem("kk_token", token);
  localStorage.setItem("kk_user",  JSON.stringify(user));
}

export function loadSession() {
  const token = localStorage.getItem("kk_token");
  const user  = localStorage.getItem("kk_user");
  if (!token || !user) return null;
  // Token süre kontrolü
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp * 1000 < Date.now()) {
      clearSession();
      return null;
    }
  } catch { return null; }
  return { token, user: JSON.parse(user) };
}

export function clearSession() {
  localStorage.removeItem("kk_token");
  localStorage.removeItem("kk_user");
}
